import React, { useState } from "react";
import "./BodyFatFAQ.css"; // Ensure appropriate styling

const BodyFatFAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const bodyFatFaqData = [
    {
      question: "What is body fat percentage?",
      answer:
        "Body fat percentage is the proportion of fat in your body compared to your total weight. It is a useful measure of fitness and overall health.",
    },
    {
      question: "Why is knowing body fat percentage important?",
      answer:
        "Understanding your body fat percentage helps assess your health, track fitness progress, and set realistic goals for fat loss or muscle gain.",
    },
    {
      question: "How accurate are body fat calculators?",
      answer:
        "Body fat calculators provide an estimate based on input data. For accurate measurements, consider methods like DEXA scans, calipers, or bioelectrical impedance analysis.",
    },
    {
      question: "What is a healthy body fat percentage?",
      answer:
        "Healthy ranges vary by age and gender. For men, 10-20% is generally considered healthy, while for women, 20-30% is typical. Consult a healthcare provider for personalized recommendations.",
    },
    {
      question: "Can I reduce body fat without losing weight?",
      answer:
        "Yes, through body recomposition. Focus on strength training and consuming enough protein to lose fat while maintaining or building muscle mass.",
    },
    {
      question: "What factors affect body fat percentage?",
      answer:
        "Genetics, diet, activity levels, age, and hormonal balance all influence body fat percentage. A balanced lifestyle can help manage these factors.",
    },
    {
      question: "How often should I check my body fat percentage?",
      answer:
        "Checking body fat every 4-6 weeks is recommended to track trends without overanalyzing daily fluctuations.",
    },
    {
      question: "What is the difference between visceral and subcutaneous fat?",
      answer:
        "Visceral fat surrounds internal organs and is linked to health risks, while subcutaneous fat is stored under the skin and is generally less harmful.",
    },
    {
      question: "Can body fat calculators differentiate fat types?",
      answer:
        "No, body fat calculators provide an overall percentage and do not distinguish between visceral and subcutaneous fat.",
    },
    {
      question: "Is BMI the same as body fat percentage?",
      answer:
        "No, BMI is a general measure of body weight relative to height, while body fat percentage provides a direct measure of body composition.",
    },
    {
      question: "What role does diet play in reducing body fat?",
      answer:
        "Diet is crucial. Consuming fewer calories than you burn, prioritizing protein, and limiting processed foods can significantly reduce body fat.",
    },
    {
      question: "How does exercise affect body fat percentage?",
      answer:
        "Exercise, especially strength training and cardio, helps reduce body fat and preserve muscle mass, leading to a healthier body composition.",
    },
    {
      question: "Can hydration levels impact body fat measurements?",
      answer:
        "Yes, hydration affects methods like bioelectrical impedance analysis. Staying hydrated ensures more consistent readings.",
    },
    {
      question: "Is it possible to have too little body fat?",
      answer:
        "Yes, essential fat is necessary for body functions. Men need at least 2-5% and women 10-13% for basic health. Too little fat can lead to health issues.",
    },
    {
      question: "What tools can I use to measure body fat percentage?",
      answer:
        "Options include online calculators, skinfold calipers, bioelectrical impedance scales, hydrostatic weighing, and DEXA scans.",
    },
    {
      question: "Does age impact body fat percentage?",
      answer:
        "Yes, body fat tends to increase with age due to changes in metabolism and activity levels. Adjusting diet and exercise can help manage this.",
    },
    {
      question: "Can stress influence body fat percentage?",
      answer:
        "Yes, chronic stress increases cortisol levels, which can lead to fat accumulation, especially visceral fat. Stress management can help maintain a healthy body composition.",
    },
    {
      question: "What is essential fat?",
      answer:
        "Essential fat is the minimum fat your body needs for vital functions, such as hormone regulation and organ protection. It is different from storage fat.",
    },
    {
      question: "How do hormones affect body fat levels?",
      answer:
        "Hormones like insulin, cortisol, and estrogen impact how and where fat is stored. Imbalances can affect body fat levels and distribution.",
    },
    {
      question: "What is body recomposition, and how can it help?",
      answer:
        "Body recomposition focuses on losing fat while gaining muscle. It requires a balance of strength training, proper nutrition, and sufficient protein intake.",
    },
  ];

  return (
    <section className="body-fat-faq-section">
      <h2>FAQs</h2>
      <div className="faq-container" id="faq">
        {bodyFatFaqData.map((faq, index) => (
          <div key={index} className="faq-item">
            <div className="faq-question" onClick={() => handleToggle(index)}>
              {faq.question}
              <span
                className={`faq-arrow ${activeIndex === index ? "rotate" : ""}`}
              ></span>
            </div>
            {activeIndex === index && (
              <div className="faq-answer">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default BodyFatFAQ;
